import { clearCustomerInformationFromLocalStorage } from "../clearCustomerDataInLocalStorage/clearCustomerDataInLocalStorage";

export const clearCustomer = () => {
  return (dispatch, getState, { api }) => {
    return api.clearCustomerData("ALL").then(
      async () => {
        window.sessionStorage.removeItem("hostingAutoAddedToCart");
        window.sessionStorage.removeItem("ChosenPackage");
        window.sessionStorage.removeItem("cart");

        return clearCustomerInformationFromLocalStorage();
      },
      (err) => {
        return false;
      },
    );
  };
};
